import React from 'react';
import './termsAndConditions.scss';

const TermsAndConditions: React.FC = () => {
  return (
    <div className="terms-and-conditions">
      <div className="terms-and-conditions-container">
        <h1>Terms and Conditions</h1>
        <div className="terms-and-conditions-content">
          <p><strong>Effective date:</strong> 28th day of July, 2025</p>

          <p>Welcome to ca.sitewalker.org (the "Site"). These terms and conditions (the "Terms") govern your use of our Site and the services we provide.</p>

          <h2>1. Acceptance of Terms</h2>
          <p>By accessing and using this Site, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.</p>

          <h2>2. Use License</h2>
          <p>Permission is granted to temporarily download one copy of the materials (information or software) on ca.sitewalker.org for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:</p>
          <ul>
            <li>Modify or copy the materials;</li>
            <li>Use the materials for any commercial purpose or for any public display (commercial or non-commercial);</li>
            <li>Attempt to decompile or reverse engineer any software contained on ca.sitewalker.org;</li>
            <li>Remove any copyright or other proprietary notations from the materials; or</li>
            <li>Transfer the materials to another person or "mirror" the materials on any other server.</li>
          </ul>

          <h2>3. Disclaimer</h2>
          <p>The materials on ca.sitewalker.org are provided on an 'as is' basis. ca.sitewalker.org makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.</p>

          <h2>4. Limitations</h2>
          <p>In no event shall ca.sitewalker.org or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on ca.sitewalker.org, even if ca.sitewalker.org or a ca.sitewalker.org authorized representative has been notified orally or in writing of the possibility of such damage.</p>

          <h2>5. Accuracy of Materials</h2>
          <p>The materials appearing on ca.sitewalker.org could include technical, typographical, or photographic errors. ca.sitewalker.org does not warrant that any of the materials on its website are accurate, complete or current. ca.sitewalker.org may make changes to the materials contained on its website at any time without notice.</p>

          <h2>6. Links</h2>
          <p>ca.sitewalker.org has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by ca.sitewalker.org of the site. Use of any such linked website is at the user's own risk.</p>

          <h2>7. Modifications</h2>
          <p>ca.sitewalker.org may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these Terms of Service.</p>

          <h2>8. Governing Law</h2>
          <p>These terms and conditions are governed by and construed in accordance with the laws of California and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.</p>

          <h2>9. User Responsibilities</h2>
          <p>As a user of this Site, you agree to:</p>
          <ul>
            <li>Provide accurate and complete information when creating an account;</li>
            <li>Maintain the security of your account credentials;</li>
            <li>Use the Site only for lawful purposes;</li>
            <li>Not interfere with or disrupt the Site's functionality;</li>
            <li>Report any security vulnerabilities or issues you discover;</li>
            <li>Comply with all applicable laws and regulations.</li>
          </ul>

          <h2>10. Data and Privacy</h2>
          <p>Your use of this Site is also governed by our Privacy Policy, which is incorporated into these Terms by reference. By using the Site, you consent to the collection and use of information as detailed in our Privacy Policy.</p>

          <h2>11. Termination</h2>
          <p>We may terminate or suspend your account and bar access to the Service immediately, without prior notice or liability, under our sole discretion, for any reason whatsoever and without limitation, including but not limited to a breach of the Terms.</p>

          <h2>12. Contact Information</h2>
          <p>If you have any questions about these Terms and Conditions, please contact us at:</p>

          <div className="contact-info">
            <p>Aura Technology<br />
              4707 Greenleaf Ct Suite A<br />
              Modesto CA 95356</p>
          </div>

          <div className="copyright">
            <p>©2002-2023 LawDepot.com®</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions; 